const text = value => typeof value === 'string' ? value.trim() : '';
// URL 입력의 제어 문자와 역슬래시를 차단한다.
// eslint-disable-next-line no-control-regex
const controls = /[\u0000-\u001f\u007f\\]/;

export function contactLink(value) {
  const input = text(value);
  const plain = { kind: 'text', href: null };
  if (!input || controls.test(input)) return plain;
  if (/^\+?[0-9][0-9 ()-]*[0-9]$/.test(input)) {
    const digits = input.replace(/[^0-9]/g, '');
    if (digits.length >= 7 && digits.length <= 15) return { kind: 'phone', href: `tel:${input.startsWith('+') ? '+' : ''}${digits}` };
  }
  if (/^[A-Za-z0-9.!#$%&'*+/=^_`{|}~-]+@[A-Za-z0-9](?:[A-Za-z0-9.-]*[A-Za-z0-9])?\.[A-Za-z]{2,63}$/.test(input)) {
    const [local, domain] = input.split('@');
    return { kind: 'email', href: `mailto:${encodeURIComponent(local)}@${domain}` };
  }
  const explicit = /^https?:\/\//i.test(input);
  if (!explicit && (/^[A-Za-z][A-Za-z0-9+.-]*:/.test(input) || /\s/.test(input))) return plain;
  try {
    const url = new URL(explicit ? input : `https://${input}`);
    if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || !url.hostname) return plain;
    if (!explicit) {
      const labels = url.hostname.split('.');
      if (labels.length < 2 || !labels.every(label => /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/i.test(label)) || !/^(?:[a-z]{2,63}|xn--[a-z0-9-]+)$/i.test(labels[labels.length - 1])) return plain;
    }
    return { kind: 'web', href: url.href };
  } catch { return plain; }
}

export function hasContactProfileInput(profile) {
  return !!(profile && (text(profile.name) || text(profile.introduction) || text(profile.website) || profile.photo || profile.contacts?.some(item => text(item?.label) || text(item?.value))));
}

export function validateContactProfile(value, scope) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('담당자 연락처 설정을 확인해주세요.');
  const field = (key, limit, required = false) => {
    if (!required && value[key] == null) return '';
    if (typeof value[key] !== 'string' || Array.from(value[key].trim()).length > limit || (required && !value[key].trim())) throw new Error(`${{ name: '담당자 이름', introduction: '자기소개', website: '대표 웹사이트' }[key]} 항목을 확인해주세요. (최대 ${limit}자)`);
    return value[key].trim();
  };
  const name = field('name', 80, true), introduction = field('introduction', 99), website = field('website', 2048);
  if (!Array.isArray(value.contacts) || value.contacts.length < 1 || value.contacts.length > 3) throw new Error('연락처는 1~3개 등록해주세요.');
  const contacts = value.contacts.map(item => {
    if (!item || typeof item.label !== 'string' || typeof item.value !== 'string' || !item.label.trim() || !item.value.trim() || Array.from(item.label.trim()).length > 40 || Array.from(item.value.trim()).length > 500) throw new Error('각 연락처의 연락명(40자 이하)과 연락처 또는 링크(500자 이하)를 모두 입력해주세요.');
    return { label: item.label.trim(), value: item.value.trim() };
  });
  if (website && contactLink(website).kind !== 'web') throw new Error('대표 웹사이트 주소를 확인해주세요.');
  let photo = null;
  if (value.photo != null) {
    const p = value.photo;
    if (!p || typeof p.url !== 'string' || p.url.length > 2048 || controls.test(p.url) || typeof p.storagePath !== 'string' || p.storagePath.length > 500) throw new Error('담당자 사진 경로를 확인해주세요.');
    try {
      const url = new URL(p.url, 'https://profile.invalid');
      const accountCode = url.searchParams.get('accountCode');
      const asset = url.searchParams.get('asset');
      if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || url.pathname !== '/.netlify/functions/workspace-media' || !/^[0-9A-F]{2}$/.test(accountCode || '') || !/^system-settings\/[A-Za-z0-9_-]+\.(png|jpg|jpeg|webp)$/i.test(asset || '')) throw new Error();
      if (!/^workspaces\/[A-Za-z0-9_-]+\/system-settings\/[A-Za-z0-9_-]+\.(png|jpg|jpeg|webp)$/i.test(p.storagePath) || !p.storagePath.endsWith(`/${asset}`)) throw new Error();
      if (scope && (accountCode !== scope.accountCode || p.storagePath !== `workspaces/${scope.workspaceId}/${asset}`)) throw new Error();
      photo = { url: `/.netlify/functions/workspace-media?accountCode=${accountCode}&asset=${encodeURIComponent(asset)}`, storagePath: p.storagePath };
    } catch { throw new Error('해당 Workspace에 업로드한 사진을 사용해주세요.'); }
  }
  return { name, photo, introduction, contacts, website };
}

export function publicContactProfile(value, scope) {
  try {
    const profile = validateContactProfile(value, scope);
    return { name: profile.name, photo: profile.photo ? { url: profile.photo.url } : null,
      introduction: profile.introduction, contacts: profile.contacts, website: profile.website };
  } catch { return null; }
}
